<template>
  <div class="content_box leads" @click="isShowSearchType = false">
    <div class="el-carousel__item home_bg"></div>
    <div class="new-home-wrap">
      <Header :fontColor="'#fff'"></Header>
      <div class="new-home-search">
        <div class="new-search-country-con">
          <div
            class="search_type"
            @click.stop="isShowSearchType = !isShowSearchType"
          >
            <span>{{ searchType }}</span>
            <i
              class="iconfont icon-jiantouxia"
              :class="{ open_search: isShowSearchType }"
            ></i>
          </div>
          <div
            class="search_type_select"
            :class="{ search_type_select_show: isShowSearchType }"
          >
            <div
              class="search_type_select_list"
              :class="{ active: searchType == lead.title }"
              @click.stop="choseSearchType(lead)"
              v-for="lead in leadsSelectType"
              :key="lead.index"
            >
              {{ lead.title }}
            </div>
          </div>
          <el-autocomplete
            clearable
            v-model="searchKeyword"
            style="width: 100%; height: auto"
            :highlight-first-item="true"
            :debounce="300"
            :trigger-on-focus="false"
            :autofocus="true"
            class="search-country-input"
            @select="handleSelect"
            :fetch-suggestions="querySearchAsync"
            :placeholder="placeholder"
            size="large"
            value-key="optionsContent"
            v-if="
              searchType == 'Product' ||
              searchType == 'HSCode - Harmonized System Code'
            "
          >
            <template #default="{ item }">
              <div class="autocomplete-item">
                {{ item.optionsCode }} - {{ item.optionsContent }}
              </div>
            </template>
          </el-autocomplete>

          <el-input
            v-if="
              searchType != 'Product' &&
              searchType != 'HSCode - Harmonized System Code'
            "
            v-model="searchSicKeyword"
            :placeholder="placeholder"
            clearable
            size="large"
            style="width: 100%; height: auto"
            class="search-country-input"
            @input="onInputSic"
          ></el-input>
          <div
            v-if="
              searchType != 'Product' &&
              searchType != 'HSCode - Harmonized System Code'
            "
            ref="sicRef"
            class="country-popper"
            :class="{ 'country-show-popper': isSicShow && !isShowSearchType }"
          >
            <div class="country-popper-arrow"></div>
            <div class="country-popper-con">
              <div class="state-con">
                <div
                  class="country-state-item"
                  :class="{ activeState: selectStateIndex == index }"
                  v-for="(item, index) in ProductList"
                  :key="index"
                  @click="onChangeSic(index)"
                >
                  <span class="country-name">{{ item.optionsContent }}</span>
                </div>
              </div>
              <div class="state-country-con">
                <div
                  class="pro_item"
                  v-for="(item, index) in ProductList[selectStateIndex]?.list"
                  :key="index"
                  @click="
                    handleSelect(
                      item,
                      ProductList[selectStateIndex].optionsContent,
                    )
                  "
                >
                  {{ item.optionsCode }} - {{ item.optionsContent }}
                </div>
              </div>
            </div>
          </div>

          <div class="search_btn" @click.stop="searhLeads(searchKeyword)">
            <i class="iconfont icon-search"></i>
            Search
          </div>
        </div>
      </div>
      <div class="new-home-search-text">
        Transform global trade data into strategic market insights
      </div>
      <!-- 底部 -->
      <div class="new-home-bottom">
        <div class="new-home-title">Bringing Global Business Into Focus</div>
        <div class="new-home-bottom-card">
          <div class="new-home-card-left leadsBack">
            <img :src="ellipseImg" />
            <div
              class="slider-box"
              @click="goPage('https://www.csibizinfo.com/?Form=Csi')"
            >
              <div class="slider-con">
                <div
                  class="slider-item"
                  v-for="(item, index) in textList"
                  :key="index"
                >
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>
          <div class="new-home-card-middle">
            <div
              class="new-home-middle-img"
              :style="{ backgroundImage: 'url(' + middleImg + ')' }"
            ></div>
            <div
              class="new-home-middle-text"
              @click="goPage('https://www.csibizinfo.com/')"
            >
              CSI, a data-driven research and IT firm, specializes in credit,
              risk, and big data. It offers digital tools to global investors
              and business professionals, leveraging advanced analytics and
              algorithms to provide fast, visual insights that facilitate
              smarter decision-making.
            </div>
          </div>
          <div class="new-home-card-right">
            <div class="new-home-right-img">
              <img :src="wechatImg" />
            </div>
            <div class="new-home-right-text">
              To quickly search, view, and obtain company information, you can
              also use the CSI App on your phone.
            </div>
          </div>
        </div>
      </div>
    </div>
    <Login :loginAndCreatePop.sync="loginDialog"></Login>
  </div>
</template>
<script>
import {
  getLeadsHomeProList,
  getSicIndustryCode,
  getHsSearch,
} from "@/api/companyApi.js";
import Header from "@/views/newLayout/header.vue";
import SearchCon from "@/views/newLayout/searchCon.vue";
import Login from "@/components/login.vue";
export default {
  name: "LeadsIndex",
  components: { Header, SearchCon, Login },
  data() {
    return {
      searchType: "Product",
      searchKeyword: "",
      searchSicKeyword: "",
      isShowSearchType: false,
      loginDialog: false,
      offest: 38,
      ellipseImg: require("@/assets/images/newPage/ellipse.png"),
      middleImg: require("@/assets/images/newPage/home-center.jpg"),
      wechatImg: require("@/assets/images/newPage/wechat.png"),
      isSicShow: false,
      selectStateIndex: 0,
      textList: [
        {
          title: "Business Intelligence",
        },
        {
          title: "Company Identity Verification",
        },
        {
          title: "KYC Solutions",
        },
        {
          title: "Company Financial Analysis",
        },
        {
          title: "Credit Ratings",
        },
        {
          title: "Credit Reports",
        },
        {
          title: "ESG Ratings",
        },
        {
          title: "Vendor Screening",
        },
        {
          title: "Market Research",
        },
        {
          title: "Industry Analysis",
        },
        {
          title: "Business Analytics",
        },
        {
          title: "Import-Export Data",
        },
        {
          title: "Company News",
        },
        {
          title: "Sanctions",
        },
        {
          title: "Search Leads",
        },
        {
          title: "Business Intelligence",
        },
        {
          title: "Company Identity Verification",
        },
        {
          title: "KYC Solutions",
        },
        {
          title: "Company Financial Analysis",
        },
        {
          title: "Credit Ratings",
        },
        {
          title: "Credit Reports",
        },
        {
          title: "ESG Ratings",
        },
        {
          title: "Vendor Screening",
        },
        {
          title: "Market Research",
        },
        {
          title: "Industry Analysis",
        },
        {
          title: "Business Analytics",
        },
        {
          title: "Import-Export Data",
        },
        {
          title: "Company News",
        },
        {
          title: "Sanctions",
        },
        {
          title: "Search Leads",
        },
      ],

      leadsSelectType: [
        {
          id: 1,
          title: "Product",
        },
        {
          id: 2,
          title: "SIC - Standard Industry Code",
        },
        {
          id: 3,
          title: "HSCode - Harmonized System Code",
        },
        // {
        //   id: 4,
        //   title: "GPC - Global Product Classification",
        // },
        {
          id: 5,
          title: "AI Assistance",
        },
      ],
      placeholder: "Enter Product Name",
      ProductList: [],
      optionsCode: "",
    };
  },
  methods: {
    // product 内容下拉取
    querySearchAsync(queryString, cb) {
      const token = localStorage.getItem("token");
      if (token) {
        if (queryString !== "") {
          if (this.searchType == "Product") {
            getLeadsHomeProList({
              pageSize: 100,
              productNameDesc: queryString,
            }).then((res) => {
              if (res.code == 200) {
                const restaurants = res.data || []; // 确保res.data是数组
                const results = queryString
                  ? restaurants.filter(this.createFilter(queryString))
                  : restaurants;
                cb(results);
              }
            });
          } else {
            getHsSearch({
              optionsContent: queryString,
            }).then((res) => {
              if (res.code == 200) {
                const restaurants = res.data || []; // 确保res.data是数组
                const results = queryString
                  ? restaurants.filter(this.createFilter(queryString))
                  : restaurants;
                cb(results);
              }
            });
          }
        }
      } else {
        this.loginDialog = true;
        cb([]);
      }
    },

    createFilter(queryString) {
      const lowercaseQuery = queryString.toLowerCase();
      return (restaurant) => {
        const optionsCode = (restaurant.optionsCode || "").toLowerCase();
        const optionsContent = (restaurant.optionsContent || "").toLowerCase();
        return (
          optionsCode.indexOf(lowercaseQuery) !== -1 ||
          optionsContent.indexOf(lowercaseQuery) !== -1
        );
      };
    },

    choseSearchType(item) {
      this.searchType = item.title;
      this.isShowSearchType = false;
      this.$refs.searchTypeRef;
      if (item.id == 1) {
        this.placeholder = "Enter Product Name";
      } else if (item.id == 2) {
        this.placeholder = " Enter ISIC / NACE / NAICS / CSIC / AAAIC / GICS";
        this.onInputSic(this.searchSicKeyword); //sic
      } else if (item.id == 3) {
        this.placeholder = "Enter Harmonized System Code";
        this.querySearchAsync(this.searchSicKeyword, (results) => {}); //hs
      } else if (item.id == 4) {
        this.placeholder = "Enter Global Product Classification";
      } else if (item.id == 5) {
        const token = localStorage.getItem("token");
        if (token) {
          this.$router.push({
            path: "/index/list/risk",
            query: {
              keyword: "",
              selectCode: 4,
            },
          });
        } else {
          this.loginDialog = true;
        }
      }
    },

    handleSelect(item, optionsType) {
      console.log(item, optionsType);
      this.optionsCode = item.optionsContent;
      if (this.searchType == "Product") {
        this.$router.push({
          path: "/index/list/risk",
          query: {
            keyword: item.optionsCode,
            selectCode: 1,
          },
        });
      } else if (this.searchType == "SIC - Standard Industry Code") {
        this.isSicShow = false;
        this.searchSicKeyword = item.optionsCode + " - " + item.optionsContent;
        this.$router.push({
          path: "/index/list/risk",
          query: {
            optionsType: optionsType,
            keyword: item.optionsCode,
            selectCode: 2,
          },
        });
      } else if (this.searchType == "HSCode - Harmonized System Code") {
        this.$router.push({
          path: "/index/list/risk",
          query: {
            keyword: item.optionsCode,
            selectCode: 3,
          },
        });
      } else {
        this.$router.push({
          path: "/index/list/risk",
          query: {
            keyword: "",
            selectCode: 4,
          },
        });
      }
    },
    // 检索
    searhLeads(val) {
      const token = localStorage.getItem("token");
      if (token) {
        if (this.searchKeyword == "" || this.searchKeyword == null) {
          this.$message({
            message: this.placeholder,
            center: true,
            type: "error",
          });
          return;
        }
        this.handleSelect({ optionsContent: val }, "");
      } else {
        this.loginDialog = true;
      }
    },
    goPage(value) {
      window.open(value, "_blank");
    },
    scrollInit() {
      if (document.body.clientWidth >= 1510) {
        this.offest = 38;
      } else {
        this.offest = 22;
      }
      const body = document.querySelector(".slider-box");
      if (body) {
        const bodyRect = body.getBoundingClientRect();

        const bodyCenterY = bodyRect.top + bodyRect.height / 2;
        document.querySelectorAll(".slider-item").forEach((li) => {
          const liRect = li.getBoundingClientRect();
          const liCenterY = liRect.top + liRect.height / 2 + this.offest;

          if (Math.abs(bodyCenterY - liCenterY) < liRect.height / 2) {
            li.classList.add("active");
          } else {
            li.classList.remove("active");
          }
        });
      }
    },

    //级联下拉
    onChangeSic(index) {
      this.selectStateIndex = index;
    },

    // 输入框输入事件
    onInputSic(val) {
      if (val) {
        console.log(val, "111val");
        getSicIndustryCode({
          optionsContent: val,
        }).then((res) => {
          if (res.code == 200) {
            const restaurants = res.data || [];
            // 过滤结果，支持模糊查询optionsCode或optionsContent
            const filteredResults = restaurants
              .map((category) => ({
                ...category,
                list: category.list.filter((item) => {
                  const lowercaseVal = val.toLowerCase();
                  const itemCode = (item.optionsCode || "").toLowerCase();
                  const itemContent = (item.optionsContent || "").toLowerCase();
                  return (
                    itemCode.indexOf(lowercaseVal) !== -1 ||
                    itemContent.indexOf(lowercaseVal) !== -1
                  );
                }),
              }))
              .filter((category) => category.list.length > 0);

            this.ProductList = filteredResults;
            this.isSicShow = true;
          }
        });
      } else {
        this.isSicShow = false;
      }
    },
  },
  mounted() {
    setInterval(this.scrollInit, 100);
  },
  beforeDestroy() {
    clearInterval(this.scrollInit);
  },
};
</script>
<style scoped>
.search_type {
  width: 188px;
  height: 70px;
  background: #ffffff;
  border-radius: 35px 0 0 35px;
  padding: 20px 0 20px 20px;
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #1a2332;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  cursor: pointer;
  position: relative;
}

.search_type span {
  flex: 1;
  text-align: left;
}

.search_type i {
  width: 30px;
}

.search_type_select {
  position: absolute;
  top: 80px;
  left: 0;
  padding: 12px 0;
  width: 300px;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: -1;
  opacity: 0;
  transform: perspective(300px) rotateX(-10deg);
  transform-origin: 50% 0;
  pointer-events: none;
  transition: all 0.3s ease-in-out;
}

.search_type_select_show {
  opacity: 1;
  z-index: 9;
  pointer-events: all;
  transform: rotateX(0deg);
}

.search_type_select_list {
  width: 100%;
  line-height: 40px;
  cursor: pointer;
  font-size: 18px;
  padding: 0 20px;
}

.search_type_select_list.active {
  background: #f5f5f5;
  color: #8e86dd;
}

.search_input {
  flex: 1;
}

.search_input >>> .el-input__inner {
  height: 100%;
  border: none;
  padding-left: 20px;
  font-size: 18px;
  color: #1a2332;
}

.search_input >>> .el-input__inner::placeholder {
  font-size: 18px;
  color: #999999;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}

.search_btn {
  position: relative;
  left: 1px;
  width: 150px;
  height: 70px;
  background: #8e86dd;
  border-radius: 0px 35px 35px 0px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #ffffff;
  line-height: 20px;
  font-style: normal;
  padding-left: 10px;
}

.search_btn i {
  font-size: 36px;
}

.risk_desc ul li:before {
  background: #b44818;
}

.open_search {
  transform: rotate(180deg);
  transition: 0.1s;
}

.new-home-con {
  flex: 1;
  position: relative;
}

.new-home-con .el-carousel {
  height: 100%;
}

.new-home-con >>> .el-carousel__container {
  height: 100%;
}

.new-home-con >>> .el-carousel__item {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.new-home-con >>> .el-carousel__indicators--horizontal {
  display: flex;
  align-items: center;
  height: 8px;
  bottom: 3%;
}

.new-home-con >>> .el-carousel__indicator {
  padding: 0;
}

.new-home-con >>> .el-carousel__indicator:not(:last-child) {
  margin-right: 6px;
}

.new-home-con >>> .el-carousel__button {
  width: 8px;
  height: 8px;
  opacity: 1;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.51);
}

.new-home-con >>> .el-carousel__indicator.is-active .el-carousel__button {
  background: rgba(255, 255, 255, 1);
}

.new-home-con .new-home-wrap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100vh - 7vh);
  z-index: 2;
}

.new-home-search-text {
  width: 100%;
  font-size: 18px;
  color: #ffffff;
  line-height: 30px;
  text-shadow: 0px 2px 2px rgba(19, 18, 33, 0.8);
  text-align: center;
  position: relative;
}

.new-home-bottom {
  position: absolute;
  bottom: 7vh;
  left: 50%;
  transform: translateX(-50%);
  width: 82.709%;
}

.new-home-title {
  width: calc(100% - 40px);
  height: 88px;
  margin: 0 auto;
  line-height: 88px;
  padding-left: 20px;
  font-size: 34px;
  color: #ffffff;
  text-shadow: 0px 2px 2px rgba(6, 59, 64, 0.5);
  background: rgba(94, 93, 105, 0.45);
  border-radius: 6px;

  backdrop-filter: blur(8px);
}

.new-home-bottom-card {
  display: flex;
  height: 352px;
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
}

.new-home-card-left,
.new-home-card-middle {
  flex: 1;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
}

.new-home-card-left {
  position: relative;
  padding-left: 50px;
  background: #1290c9;
}

.new-home-card-left img {
  position: absolute;
  top: 110px;
  left: 14px;
  width: 22px;
  height: 16px;
}

.new-home-card-left .slider-box {
  position: relative;
  height: 100%;
  overflow: hidden;
}

.new-home-card-left .slider-con {
  display: flex;
  flex-direction: column;
  /* 内容排列为竖直方向 */
  padding-top: 14px;
  animation: scrollTop 25s linear infinite;
  will-change: transform;
}

@keyframes scrollTop {
  0% {
    transform: translateY(0);
    /* 初始位置 */
  }

  100% {
    transform: translateY(-47%);
  }
}

.new-home-card-left .slider-item {
  display: flex;
  align-items: center;
  height: 28px;
  line-height: 28px;
  font-weight: bold;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.4);
  transition: 0.5s ease-in-out !important;
  cursor: pointer;
}

.new-home-card-left .slider-item.active {
  font-size: 24px;
  color: #ffffff;
}

.new-home-card-left .slider-item:not(:last-child) {
  margin-bottom: 2px;
}

.new-home-card-middle {
  position: relative;
  margin: 0 14px;
  background-position: left center;
  background-size: cover;
  overflow: hidden;
}

.new-home-middle-img {
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate3d(-42%, 0%, 0);
  max-width: none;
  width: 703px;
  height: 399px;
  background-position: center center;
  background-size: cover;
  /* will-change: transform; */
  animation: scrollImg 12s linear infinite alternate;
}

@keyframes scrollImg {
  0% {
    transform: translate3d(-42%, 0%, 0);
  }

  50% {
    transform: translate3d(-50%, 0%, 0);
  }

  100% {
    transform: translate3d(-58%, 0%, 0);
  }
}

.new-home-middle-text {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 30px 20px;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 22px;
  text-align: justify;
  cursor: pointer;
}

.new-home-middle-text:hover {
  text-decoration: underline;
}

.new-home-card-right {
  width: 300px;
  padding: 40px 10px 0 10px;
  background: #f5f5f5;
  border-radius: 12px;
}

.new-home-right-img {
  width: 120px;
  height: 120px;
  padding: 3px;
  margin: 0 auto 16px auto;
  background: #ffffff;
}

.new-home-right-text {
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  text-align: center;
}

.search-country-input {
  flex: 1;
  padding: 0 20px;
}

.search-country-input >>> .el-input__inner {
  line-height: 70px;
  font-size: 16px;
  padding: 0 !important;
  color: #1a2332;
  border: none !important;
  border-radius: 0;
}

.search-country-input >>> .el-input__inner::placeholder {
  font-weight: 400;
  color: #8497ab;
}

.search_type::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 30px;
  background: #dddddd;
}
.country-popper {
  position: absolute;
  top: 84px;
  left: 58%;
  transform: translateX(-50%);
  width: 850px;
  height: 300px;
  padding: 18px 5px 0px 0;
  margin-top: 0 !important;
  background: #ffffff;
  box-shadow: 0px -8px 20px 0px rgba(10, 33, 57, 0.24);
  border-radius: 12px;
  z-index: -1;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease-in-out;
}

.country-show-popper {
  width: 850px;
  height: 300px;
  opacity: 1;
  z-index: 9;
  pointer-events: all;
  transition: all 0.3s ease-in-out;
}
.country-popper-arrow,
.country-popper-arrow::after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}

.country-popper-arrow {
  left: 236px;
  top: -12px;
  border-width: 12px;
  border-top-width: 0;
  border-bottom-color: #ffffff;
}

.country-popper-arrow::after {
  content: "";
  border-width: 12px;
  border-bottom-color: #ffffff !important;
  filter: drop-shadow(0px -8px 20px 0px rgba(10, 33, 57, 0.24)) !important;
}

.country-popper-con {
  display: flex;
  height: 100%;
  overflow: hidden;
}

.country-popper-con .state-con {
  width: 80px;
  height: calc(100% - 18px);
  flex-shrink: 0;
  border-right: 1px solid #dddddd;
  overflow: auto;
}

.country-popper-con .country-state-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 42px;
  padding: 0 10px;
  cursor: pointer;
}
.country-popper-con .pro_item {
  width: 100%;
  line-height: 34px;
  cursor: pointer;
  color: #1a2332;
  font-size: 16px;
  list-style: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.country-popper-con .country-name {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  font-size: 16px;
  color: #1a2332;
}
.pro_item:hover,
.country-popper-con .country-state-item.activeState .country-name,
.country-popper-con .country-state-item.activeState {
  background: #f5f5f5;
  color: #8e86dd;
}
.country-popper-con .state-country-con {
  width: 766px;
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-content: flex-start;
  padding-left: 20px;
  overflow: auto;
}

.country-popper-con .pro:not(:nth-child(4n)) {
  margin-right: 10px;
}

.country-popper-con .state-country-info {
  flex: 1;
  overflow: hidden;
}
.autocomplete-item,
.country-popper-con .state-country-name {
  margin-bottom: 4px;
  font-size: 16px;
  color: #1a2332;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.country-popper-con .state-country-name {
  line-height: 20px;
}
.autocomplete-item {
  line-height: 34px;
}
.country-popper-con .state-country-companyCount {
  font-size: 14px;
  color: #999999;
  line-height: 1;
}

@media (max-width: 1920px) {
  .search_type {
    width: 160px;
    height: 50px;
    background: #ffffff;
    border-radius: 25px 0 0 25px;
    padding: 5px 10px 5px 15px;
    font-size: 14px;
    line-height: 16px;
  }

  .search_type::after {
    height: 22px;
  }

  .search_type i {
    width: auto;
    font-size: 16px;
  }

  .search_type_select {
    position: absolute;
    top: 60px;
    left: 0;
    padding: 10px 0;
    width: 280px;
    gap: 5px;
  }

  .search_type_select_list {
    line-height: 30px;
    font-size: 14px;
    padding: 0 15px;
  }

  .search_input >>> .el-input__inner {
    padding-left: 16px;
    font-size: 16px;
  }

  .search_input >>> .el-input__inner::placeholder {
    font-size: 16px;
    line-height: 16px;
  }

  .search_btn {
    width: 110px;
    height: 50px;
    border-radius: 0px 25px 25px 0px;
    font-size: 14px;
    line-height: 16px;
  }

  .search_btn i {
    font-size: 26px;
    margin-right: 5px;
  }

  .new-home-search-text {
    font-size: 14px;
    line-height: 20px;
  }

  .new-home-bottom {
    width: 1300px;
  }

  .new-home-title {
    width: calc(100% - 32px);
    height: 70px;
    line-height: 70px;
    padding-left: 16px;
    font-size: 28px;
    border-radius: 5px;
  }

  .new-home-bottom-card {
    height: 282px;
    padding: 16px;
    border-radius: 10px;
  }

  .new-home-card-left,
  .new-home-card-middle {
    border-radius: 10px;
  }

  .new-home-card-left {
    padding-left: 40px;
  }

  .new-home-card-left img {
    top: 80px;
    left: 11px;
    width: 18px;
    height: 14px;
  }

  .new-home-card-left .slider-con {
    padding-top: 11px;
  }

  .new-home-card-left .slider-item {
    height: 24px;
    line-height: 24px;
    font-size: 14px;
  }

  .new-home-card-left .slider-item.active {
    font-size: 20px;
  }

  .new-home-card-middle {
    margin: 0 12px;
  }

  .new-home-middle-img {
    width: 562px;
    height: 320px;
  }

  .new-home-middle-text {
    padding: 24px 16px;
    font-size: 14px;
    line-height: 18px;
  }

  .new-home-card-right {
    width: 240px;
    padding: 32px 8px 0 8px;
    border-radius: 10px;
  }

  .new-home-right-img {
    width: 96px;
    height: 96px;
  }

  .new-home-right-text {
    font-size: 14px;
    line-height: 18px;
  }

  .page-top-con .search-country-input {
    padding: 0 40px 0 26px;
  }

  .page-top-con .search-country-input >>> .el-input__inner {
    line-height: 36px;
    font-size: 14px;
  }

  .search-country-input {
    padding: 0 10px;
  }

  .search-country-input >>> .el-input__inner {
    line-height: 46px;
    font-size: 14px !important;
  }
  .country-popper {
    top: 58px;
    width: 630px;
    height: 200px;
    padding: 10px 3px 10px 0;
    border-radius: 4px;
  }
  .country-show-popper {
    width: 630px;
    height: 264px;
  }
  .country-popper-arrow {
    left: 50px;
    top: -6px;
    border-width: 6px;
    border-top-width: 0;
    border-bottom-color: #ffffff;
  }

  .country-popper-arrow::after {
    border-width: 8px;
  }

  .country-popper-con .state-con {
    width: 60px;
    height: 100%;
  }

  .country-popper-con .country-state-item {
    height: 40px;
    padding: 0 8px;
  }

  .country-popper-con .country-state-item:not(:last-child) {
    margin-bottom: 0px;
  }

  .country-popper-con .country-name {
    line-height: 14px;
    font-size: 14px;
  }

  .country-popper-con .state-country-con {
    width: 566px;
    padding-left: 10px;
  }

  .autocomplete-item,
  .country-popper-con .state-country-name {
    margin-bottom: 2px;
    font-size: 14px;
  }
  .country-popper-con .state-country-name {
    line-height: 14px;
  }
  .autocomplete-item {
    line-height: 34px;
  }
  .country-popper-con .state-country-companyCount {
    font-size: 12px;
  }
  .country-popper-con .pro_item {
    font-size: 14px;
  }
}

.home_bg {
  background: url("../../assets/images/0-7home-2.jpg") no-repeat;
  background-size: 100% 100%;
  background-position: center center;
}

.leadsBack {
  background-color: #8e86dd !important;
}

@media screen and (max-width: 1439px) {
  .new-home-bottom {
    width: 1100px;
  }

  .new-home-title {
    width: calc(100% - 28px);
    height: 60px;
    line-height: 60px;
    padding-left: 14px;
    font-size: 24px;
    border-radius: 4px;
  }

  .new-home-bottom-card {
    height: 246px;
    padding: 14px;
    border-radius: 8px;
  }

  .new-home-card-left,
  .new-home-card-middle {
    border-radius: 8px;
  }

  .new-home-card-left {
    padding-left: 35px;
  }

  .new-home-card-left img {
    top: 78px;
    left: 10px;
    width: 16px;
    height: 12px;
  }

  .new-home-card-left .slider-con {
    padding-top: 10px;
  }

  .new-home-card-left .slider-item {
    height: 20px;
    line-height: 20px;
    font-size: 12px;
  }

  .new-home-card-left .slider-item.active {
    font-size: 16px;
  }

  .new-home-card-middle {
    margin: 0 10px;
  }

  .new-home-middle-img {
    width: 492px;
    height: 280px;
  }

  .new-home-middle-text {
    padding: 20px 14px;
    font-size: 12px;
    line-height: 16px;
  }

  .new-home-card-right {
    width: 210px;
    padding: 28px 10px 0 7px;
    border-radius: 8px;
  }

  .new-home-right-img {
    width: 84px;
    height: 84px;
  }

  .new-home-right-text {
    font-size: 12px;
    line-height: 16px;
  }
}
</style>
